import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import api from "services/api";

import { Page } from "v2/components";
import { View } from "./View";
import { getContractDisplayName } from "v2/utils/getContractDisplayName";

interface IResponse {
  workspace: {
    id: string; //workspace_id
    workspaceRules?: Array<{
      params?: {
        payload?: {
          rules?: {
            rulesRegister?: {
              policyContractNumber?: string;
            };
          };
        };
      };
    }>;
    sellerOrganization: {
      id: string;
      corporateName: string;
    };
    buyerOrganization: {
      id: string;
      corporateName: string;
    };
    product: {
      id: string;
      name: string;
      productType: string;
      supplierOrganization: {
        id: string;
        corporateName: string;
      };
    };
  },
  posicaoWorkspaceActivityId: string;
}

export function PosicaoCadastral() {
  const { workspaceId, templateId } = useParams() as { workspaceId: string; templateId: string; };

  const { data, isFetching, isFetched, isError } = useQuery({
    queryKey: ["pageDetailPosicao", workspaceId],
    queryFn: () => api.get<{ data: IResponse }>(`/v2/workspaces/${workspaceId}/posicao-get-details`),
    select: (data) => data.data.data,
  });

  console.log(data)

  return (
    <>
      {!isFetched && isFetching && <div>Loading...</div>}
      {!isFetched && isError && <div>Error...</div>}
      {data && (
        <Page title={getContractDisplayName(data.workspace)} backRoute={`/v2/workspaces/${data.workspace.id}`}>
          <Page.Tab name="Atividades">
            <View posicaoWorkspaceActivityId={data.posicaoWorkspaceActivityId} />
          </Page.Tab>
          <Page.Tab name="Histórico" disabled />
          <Page.Tab name="Contrato" disabled />
        </Page>
      )}
    </>
  );
}
